export default {
  personalDetails: 'Personal details',
  workExperience: 'Work experience',
  preference: 'Preference',
  viewFile: 'Your uploaded file',
  jobProfile: 'Job Profile',
  fields: {
    name: 'Full Name *',
    gender: 'What is your gender? *',
    qualification: 'What is your highest qualification? *',
    specialisation: 'What is your specialisation?',
    resume: 'Do you have a resume?',
    experience: 'How long were you working *',
    pastEmployer: 'Your past employer?',
    designation: 'Your recent designation?',
    salary: 'Your recent salary?',
    jobCategory: 'What kind of job are you looking for *',
    preferredLocation: 'Your preferred location? *',
    jobType: 'Your preferred job type *',
    workType: 'Your preferred work type *',
    shiftTiming: 'Your preferred work time *'
  },
  uploadResume: 'Upload your resume',
  uploadText: 'You can upload a .jpg, .pdf or a word doc. OR take a picture',
  optional: 'Optional',
  placeholders: {
    name: 'Provide your full name for recruiters',
    specialisation: 'eg: Engineering, Arts',
    pastEmployer: 'eg: TCS, Wipro',
    designation: 'eg: Sales Manager',
    salary: 'Choose a salary range',
    jobCategory: 'Choose job categories',
    preferredLocation: 'Select multiple districts',
    searchForJobs: 'Search for jobs',
    signUp: 'Signup'
  },
  buttons: {
    uploadResume: 'Upload resume',
    capture: 'Take a picture',
    uploadFromDevice: 'Upload from device',
    next: 'Next',
    submit: 'Submit',
    done: 'Done',
    viewFile: 'View File',
    delete: 'Delete',
    change: 'Change',
    pause: 'Pause',
    retry: 'Retry'
  },
  allStates: 'Anywhere in {state}',
  jobCategory: 'Job Category',
  preferredLocation: 'Preferred Location',
  salary: 'Choose Salary Range',
  resume: 'Resume',
  recommendedJobs: 'Recommended jobs',
  sponsoredJobs: 'Sponsored jobs',
  footerFields: {
    CustomerServices: 'Customer Services',
    emailUs: 'Email us',
    privacyPolicy: 'Privacy Policy',
    termsAndConditions: 'Terms and conditions',
    needJob: 'Need a job near you?',
    jobs: '1 lakh jobs',
    sections: '40 sections'
  },
  emptyResultsScreenFields: {
    jobsByCategories: 'Jobs by Categories',
    jobsByLocation: 'Jobs by Location',
    headerMessage1: 'Sorry, we could not find any open roles for your search',
    headerMessage2: 'Signup for Job alerts and we’ll notify you when new jobs have opened up',
    explore: 'Explore jobs by categories and location',
    noOfJobs: '10 jobs',
    icon: 'icon'
  },
  exploreJobsFiltersFields: {
    Category: 'Category',
    salaryRange: 'Salary Range',
    Experience: 'Experience',
    exploreJobsHero: 'Explore by job categories'
  },
  faqFields: {
    header: 'Frequently asked questions'
  },
  homePageHeroFields: {
    findDreamJob: 'Find your dream job!',
    availableJobsAndNoOfCities: ' 50 Lakh+ Jobs | 70+ Cities',
    content: 'Apply for jobs on Lokalapp & talk to the HRs of the companies directly.'
  },
  appalyForJob: 'Apply for a Job',
  searchJob: 'Search job',
  postAJob: 'Post A job',
  jobFindingStepsFields: {
    step1: '1. Create your job Profile',
    step2: '2. Find a job vacancy',
    step3: '3. Contact the HR directly to Apply',
    hero: 'Find your dream job using Lokal in 3 simple steps:'
  },
  jobSearchPlaceHolder: 'Search for jobs',
  share: 'Share',
  shareOnWhatsApp: 'Share on WhatsApp',
  report: 'Report',
  viewJobs: 'View jobs',
  lookingForJobHero: {
    hero: 'Looking for a job?',
    content: 'The sky was cloudless and had a deep blue hue.'
  },
  postNewJobFields: {
    hero: 'Post your work Local application in 3 simple steps:',
    content1: 'Target job advertising from 250+ districts',
    content2: 'Recruit from 1 lakh eligible candidates',
    content3: 'Get maximum responses at low rates'
  },
  quickAccessFooterFields: {
    quickLinks: 'Quick Links',
    categoryWiseJobs: 'Category wise jobs',
    jobsByLocation: 'Jobs by location',
    viewAllCategories: 'View all categories',
    viewAllLocations: 'View all locations'
  },
  jobSearchPlaceHolder1: 'Enter Job title, keyword,...',
  warangal: 'warangal',
  krishna: 'krishna',
  vishakapatnam: 'Vishakapatnam',
  yadadri: 'yadadri',
  guntur: 'guntur',
  jobs: 'Jobs',
  seeAll: 'See all',
  jobListing: 'Job Listing',
  findAJob: 'Find a job',
  createAnAccount: 'Create an account',
  jobSearchAdvice: 'Job Search Advice',
  administration: 'Administration',
  digitalMarketing: 'Digital Marketing',
  design: 'Design',
  development: 'Development',
  productmanagement: 'Product management',
  finance: 'Finance',
  agra: 'Agra',
  bengaluru: 'Bengaluru',
  delhi: 'Delhi',
  mumbai: 'Mumbai',
  hi: 'Hi',
  home: 'Home',
  exploreJobs: 'Explore Jobs',
  postAJob: 'Post a Job',
  contactUs: 'Contact Us',
  contact: 'contact',
  getTheApp: 'Get the App',
  loginOrCreateAnAccount: 'Login or Create an account',
  login: 'Login',
  createYourProfile: 'Create profile',
  editProfile: 'Edit Profile',
  myProfile: 'My Profile',
  logOut: 'Log Out',
  disclosureTitle: {
    jobDetails: 'Job Details',
    feesRequired: 'Fees Required',
    noFeeIsRequired: 'No fee is required'
  },
  whyIsItNeeded: 'Why is it needed',
  emailUsOn: 'email us on',
  similarJobs: 'Similar Jobs',
  noSimilarJobs: 'No similar Jobs',
  loading: 'Loading',
  enterNewMobileNumber: 'Enter new mobile number',
  mobileNumber: 'Mobile Number',
  anOtpWillBeSentToThisNumber: 'An OTP will be sent to this number',
  welcomeToLokal: 'Welcome to Lokal',
  loginOrSignup: 'Login or Signup',
  otpDiscription:
    'Enter the mobile number you wish to be contacted on. An OTP will be sent to this number',
  iAgreeToThe: 'I agree to the',
  and: 'and',
  yesApply: 'Yes,apply',
  termsAndConditions: 'Terms & Conditions',
  privacyPolicy: 'Privacy Policy',
  continue: 'Continue',
  checkYourSms: 'Check your SMS',
  weHaveSentYouAnOtpOn: 'We have sent you an OTP on',
  changeNumber: 'Change Number',
  enterFourDigitOtp: 'Enter 4 digit OTP',
  didNotRecieveTheOtp: 'Did not receive the OTP',
  otpCheckBoxDiscription: 'I would like to receive WhatsApp notifications',
  done: 'Done',
  incorrectCredentials: 'Incorrect credentials',
  resendOtp: 'Resend OTP',
  resendOtpIn: 'Resend OTP in',
  noResultsFoundFor: 'No results found for',
  jobsTitle: 'Jobs in {location} | Find Job Vacancies in {location} : {host}/jobs',
  jobsMetaData:
    'Apply for Jobs in {location} on {host}/jobs. Register for Free & Find Job Openings in {location}',
  posted: 'Posted',
  ago: 'ago',
  views: 'views',
  cancel: ' cancel',
  pleaseTryAgain: 'Please try again',
  locationsNotAvailable: 'Locations not available',
  jobsByCategories: 'Jobs by category',
  footerModelForApplyJobFields: {
    header1: 'Are you sure want to continue',
    header2: 'Job Application has been succesfully Submitted',
    applyConformation: 'applying for this job?',
    subText1: 'if selected,you will receive a call from the recuiter',
    subText2: 'Your details will be sent to the recruiter'
  },
  advertiser: {
    whatOurUsersSay: 'What our employers have to say about Lokal'
  },
  searchJobs: 'Search Jobs',
  createFreeAccount: 'Create free account',
  jobAdvice: 'Job Advice',
  postAJob: 'Post a Job',
  mobileNumber: 'Mobile Number',
  sendOTP: 'Send OTP',
  verifyOTP: 'Verify OTP',
  downLoadApp: 'Download the app',
  jobsNearMeTitle: '{numberOfJobs} Job Openings & Vacancies  - Find the Perfect Job',
  jobsDescription:
    'Searching for jobs in {Location}? Find the latest openings and vacancies in {Location} in 2023 with Lokal Job Listings',
  postJobSteps: {
    jobDetail: 'ಕೆಲಸದ ವಿವರ',
    aboutJob: 'ಕೆಲಸದ ಬಗ್ಗೆ',
    selectRole: 'ಉದ್ಯೋಗದ ಪಾತ್ರವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    selectTitle: 'ಕೆಲಸದ ಶೀರ್ಷಿಕೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    postTitle: 'ಪೋಸ್ಟ್ ಶೀರ್ಷಿಕೆಯನ್ನು ನಮೂದಿಸಿ',
    sampleJobTypes: 'ಉದಾ. ಸೇಲ್ಸ್ ಅಕೌಂಟೆಂಟ್, ಡೆಲಿವರಿ ಬಾಯ್ ಇತ್ಯಾದಿ',
    addJobDescription: 'ಕೆಲಸದ ವಿವರಣೆಯನ್ನು ಸೇರಿಸಿ',
    removeJobDescription: 'ಕೆಲಸದ ವಿವರಣೆಯನ್ನು ತೆಗೆದುಹಾಕಿ',
    NoOfOpenings: 'ತೆರೆಯುವಿಕೆಗಳ ಸಂಖ್ಯೆ',
    enterNoOfOpenings: 'ತೆರೆಯುವಿಕೆಗಳ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ',
    monthlyIncome: 'ಮಾಸಿಕ ಆದಾಯ',
    enterMinSalary: 'ಕನಿಷ್ಠ ವೇತನವನ್ನು ನಮೂದಿಸಿ',
    enterMaxSalary: 'ಗರಿಷ್ಠ ವೇತನವನ್ನು ನಮೂದಿಸಿ',
    jobShift: 'ಉದ್ಯೋಗ ಶಿಫ್ಟ್',
    dayShift: 'ದಿನದ ಪಾಳಿ',
    nightShift: 'ರಾತ್ರಿ ಪಾಳಿ',
    anyShift: 'ಯಾವುದೇ ಶಿಫ್ಟ್',
    jobType: 'ಕೆಲಸದ ಪ್ರಕಾರ',
    fieldJob: 'ಫೀಲ್ಡ್ ಜಾಬ್',
    officeJob: 'ಕಚೇರಿ ಕೆಲಸ',
    workFromHome: 'ಮನೆಯಿಂದ ಕೆಲಸ',
    industryJob: 'ಉದ್ಯಮದ ಉದ್ಯೋಗ',
    officeLocation: 'ಕಚೇರಿ ಸ್ಥಳ',
    interstedPlace: 'ನೀವು ಎಲ್ಲಿಂದ ನೇಮಕ ಮಾಡಲು ಆಸಕ್ತಿ ಹೊಂದಿದ್ದೀರಿ?',
    district: 'ಜಿಲ್ಲೆ',
    selectMultipleDistricts: 'ಬಹು ಜಿಲ್ಲೆಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    charges: 'ಈ ಕೆಲಸಕ್ಕಾಗಿ, ನೀವು ಅಭ್ಯರ್ಥಿಗಳಿಂದ ಯಾವುದೇ ಶುಲ್ಕವನ್ನು ವಿಧಿಸುತ್ತೀರಾ',
    yes: 'ಹೌದು',
    no: 'ಇಲ್ಲ',
    reasonForFee:
      'ನಿಜವಾದ ಕಾರಣಗಳಿಗಾಗಿ ಶುಲ್ಕವನ್ನು ಸಂಗ್ರಹಿಸಲಾಗಿದೆ ಎಂಬುದನ್ನು ದಯವಿಟ್ಟು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ ಮತ್ತು ಶುಲ್ಕದ ಕಾರಣವನ್ನು ಅಭ್ಯರ್ಥಿಗೆ ಸ್ಪಷ್ಟವಾಗಿ ತಿಳಿಸಿ',
    feeAmount: 'ಶುಲ್ಕದ ಮೊತ್ತ (ರೂಪಾಯಿಗಳಲ್ಲಿ)',
    selectReasonsForFee: 'ಶುಲ್ಕದ ಕಾರಣಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    registrationFee: 'ನೋಂದಣಿ ಶುಲ್ಕ',
    trainingFee: 'ತರಬೇತಿ ಶುಲ್ಕ',
    feeForOtherReasons: 'ಸಮವಸ್ತ್ರ, ಉಪಕರಣಗಳು, ಉಪಕರಣಗಳು ಇತ್ಯಾದಿಗಳಿಗೆ ಶುಲ್ಕ.',
    securityDeposit: 'ಭದ್ರತಾ ಠೇವಣಿ',
    commission: 'ಆಯೋಗ',
    otherReason: 'ಇತರ ಕಾರಣ',
    specifyOtherReason: 'ಇತರ ಕಾರಣವನ್ನು ಸೂಚಿಸಿ (ಯಾವುದಾದರೂ ಇದ್ದರೆ)',
    feeDueDate: 'ಶುಲ್ಕವನ್ನು ಯಾವಾಗ ಪಾವತಿಸಬೇಕು',
    afterGivingJob: 'ಕೆಲಸ ಕೊಟ್ಟ ನಂತರ',
    beforeGivingJob: 'ಕೆಲಸ ಕೊಡುವ ಮುನ್ನ',
    candidateRequirement: 'ಅಭ್ಯರ್ಥಿಯ ಅವಶ್ಯಕತೆ',
    candidateQualification: 'ಅಭ್ಯರ್ಥಿಯ ಅರ್ಹತೆ',
    selectMinimumEducation: 'ಕನಿಷ್ಠ ಶಿಕ್ಷಣವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    selectYourExperience: 'ವರ್ಷಗಳ ಅನುಭವವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    preferredGender: 'ಆದ್ಯತೆಯ ಲಿಂಗ',
    male: 'ಪುರುಷ',
    female: 'ಹೆಣ್ಣು',
    anyGender: 'ಯಾವುದೇ ಲಿಂಗ',
    contactCandidatesThrough: 'ಮೂಲಕ ಅಭ್ಯರ್ಥಿಗಳನ್ನು ನಿರ್ವಹಿಸಿ',
    callOnWhatsapp: 'ಕರೆಗಳು ಮತ್ತು ವಾಟ್ಸ್ಯಾಪ್',
    callOnly: 'ಕರೆಗಳು ಮಾತ್ರ',
    whatsappNo: 'ವಾಟ್ಸಾಪ್‌ನ ಅದೇ ಸಂಖ್ಯೆ',
    next: 'ಮುಂದೆ',
    companyDetail: 'ಕಂಪನಿ ವಿವರ',
    selectCompanyType: 'ನಿಮ್ಮ ಕಂಪನಿ ಪ್ರಕಾರವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    consultancy: 'ಸಲಹಾ / ಮಾನವಶಕ್ತಿ ಸಂಸ್ಥೆ',
    hiresThirdPartyCompany: 'ನಾನು ಮೂರನೇ ವ್ಯಕ್ತಿಯ ಕಂಪನಿಗಳಿಗೆ ನೇಮಿಸಿಕೊಳ್ಳುತ್ತೇನೆ',
    company: 'ಕಂಪನಿ',
    hireForMyComapny: 'ನನ್ನ ಕಂಪನಿ / ಅಂಗಡಿಗೆ ನಾನು ಬಾಡಿಗೆಗೆ ಪಡೆಯುತ್ತೇನೆ',
    company: 'ಕಂಪನಿ',
    companyname: 'ಕಂಪನಿಯ ಹೆಸರನ್ನು ನಮೂದಿಸಿ',
    companySize: 'ಕಂಪೆನಿಯ ಗಾತ್ರ',
    largeScale: 'ದೊಡ್ಡ ಪ್ರಮಾಣದ [50+ ಉದ್ಯೋಗಿಗಳು]',
    midScale: 'ಮಧ್ಯಮ ಪ್ರಮಾಣದ [20-50 ಉದ್ಯೋಗಿಗಳು]',
    smallScale: 'ಸಣ್ಣ ಪ್ರಮಾಣದ [5-20 ಉದ್ಯೋಗಿಗಳು]',
    companyNameToBeDisplayed: 'ಈ ಉದ್ಯೋಗಕ್ಕಾಗಿ ಅಭ್ಯರ್ಥಿಗಳಿಗೆ ಕಂಪನಿಯ ಹೆಸರನ್ನು ಪ್ರದರ್ಶಿಸಬೇಕು',
    consultancyName: 'ಸಲಹಾ ಹೆಸರು',
    otherThirdPartyname: 'ಇತರ ಮೂರನೇ ವ್ಯಕ್ತಿಯ ಕಂಪನಿಯ ಹೆಸರು',
    jobDescriptionPlaceholder: 'ಉದ್ಯೋಗಿಗಳ ಜವಾಬ್ದಾರಿಗಳೇನು?',
    officeLocationCityPlaceholder: 'ನಗರ / ಪಟ್ಟಣವನ್ನು ಹುಡುಕಿ',
    officeLocationAreaPlaceholder: 'ಸ್ಥಳ / ಏರಿಯಾವನ್ನು ಹುಡುಕಿ',
    noOptionsDropdown: 'ಆಯ್ಕೆಗಳಿಗಾಗಿ ಟೈಪ್ ಮಾಡಿ',
    selectDistrict: 'ಜಿಲ್ಲೆ ಆಯ್ಕೆಮಾಡಿ',
    selectDistricts: 'ಜಿಲ್ಲೆಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    noDistrictSelected: 'ಆಯ್ಕೆ ಮಾಡಲಾಗಿದೆ',
    whatsappNumber: 'ವಾಟ್ಸಾಪ್ ನಂಬರ್',
    recruiterLogin: 'ನೀವು ರೆಕ್ರೂಟರ್ ಆಗಿ ಲಾಗ್ ಇನ್ ಆಗಿರುವಿರಿ',
    advertiserTooltip: 'ಈ ಕೆಲಸವನ್ನು ವೀಕ್ಷಿಸುವ ಅಭ್ಯರ್ಥಿಗಳಿಗೆ ನೇಮಕಾತಿ ಕಂಪನಿಯಾಗಿ ಈ ಹೆಸರನ್ನು ಪ್ರದರ್ಶಿಸಲಾಗುತ್ತದೆ.',
    consultancyManpowerFirm: 'ಕನ್ಸಲ್ಟೆನ್ಸಿ / ಮ್ಯಾನ್‌ಪವರ್ ಸಂಸ್ಥೆ',
    thirdPartyHire: 'ನಾನು ಮೂರನೇ ವ್ಯಕ್ತಿಯ ಕಂಪನಿಗಳಿಗೆ ನೇಮಿಸಿಕೊಳ್ಳುತ್ತೇನೆ',
    companyNew: 'ಕಂಪನಿ',
    companyStore: 'ನನ್ನ ಕಂಪನಿ / ಅಂಗಡಿಗೆ ನಾನು ನೇಮಕಾತಿ ಮಾಡುತ್ತೇನೆ',
    consultancyNameNew: 'ಕನ್ಸಲ್ಟೆನ್ಸಿ ಹೆಸರನ್ನು ನಮೂದಿಸಿ',
    choosePlan: 'ಪ್ಲಾನ್ ಆಯ್ಕೆ ಮಾಡಿ',
    noFeeWarning: 'ಯಾವುದೇ ಶುಲ್ಕವನ್ನು ಸಂಗ್ರಹಿಸುವುದಿಲ್ಲ ಎಂದು ದಯವಿಟ್ಟು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ. ಜಾಬ್ ಪೋಸ್ಟ್‌ಗಳನ್ನು ತೆಗೆದುಹಾಕುವ ಅಥವಾ ಅಭ್ಯರ್ಥಿಗಳನ್ನು ವಂಚಿಸುವ ಜಾಹೀರಾತುದಾರರು/ಕಂಪನಿಗಳನ್ನು ನಿರ್ಬಂಧಿಸುವ ಹಕ್ಕನ್ನು ಲೋಕಲ್ ಅಪ್ಲಿಕೇಶನ್ ಹೊಂದಿದೆ.',
    feePaidQuestion: 'ಶುಲ್ಕವನ್ನು ಯಾವಾಗ ಪಾವತಿಸಬೇಕು? (ಐಚ್ಛಿಕ)',
    feePaidCaution: 'ಜಾಬ್ ಪೋಸ್ಟ್‌ಗಳನ್ನು ತೆಗೆದುಹಾಕುವ ಅಥವಾ ಅಭ್ಯರ್ಥಿಗಳಿಗೆ ವಂಚನೆ ಮಾಡುವ ಜಾಹೀರಾತುದಾರರು/ಕಂಪನಿಗಳನ್ನು ನಿರ್ಬಂಧಿಸುವ ಹಕ್ಕನ್ನು ಲೋಕಲ್ ಅಪ್ಲಿಕೇಶನ್ ಹೊಂದಿದೆ.',
    useCurrentLocation: 'ಪ್ರಸ್ತುತ ಸ್ಥಳವನ್ನು ಬಳಸಿ',
    skillsRequired: 'ಕೌಶಲ್ಯ ಅಗತ್ಯವಿದೆ',
    addOtherSkills: 'ಇತರ ಕೌಶಲ್ಯಗಳನ್ನು ಸೇರಿಸಿ',
    additionalSkills: 'ಹೆಚ್ಚುವರಿ ಕೌಶಲ್ಯಗಳು',
    additionalSkillsMsg: 'ನೀವು ಗರಿಷ್ಠ 3 ಹೆಚ್ಚುವರಿ ಕೌಶಲ್ಯಗಳನ್ನು ಸೇರಿಸಬಹುದು',
    additionalSkillsPlaceholder: 'ಅಲ್ಪವಿರಾಮದಿಂದ ಬೇರ್ಪಟ್ಟ ಇತರ ಕೌಶಲ್ಯಗಳನ್ನು ಸೇರಿಸಿ',
    perDistrictChargeOne: 'ನೀವು ಪೇಯ್ಡ್ ಪ್ಲಾನ್ ಖರೀದಿಸಿದರೆ',
    perDistrictChargeTwo: 'ನಿಮಗೆ',
    perDistrictChargeThree: 'ಪ್ರತಿ ಜಿಲ್ಲೆಯ ಆಧಾರದ ಮೇಲೆ ಶುಲ್ಕ ವಿಧಿಸಲಾಗುತ್ತದೆ',
    skillsSelectedPlaceholder: 'ಸ್ಕಿಲ್ಸ್ ಆಯ್ಕೆ ಮಾಡಲಾಗಿದೆ',
    industryLocation: 'ಇಂಡಸ್ಟ್ರಿ ಲೊಕೇಶನ್',
    fieldLocation: 'ಫೀಲ್ಡ್ ಲೊಕೇಶನ್',
    workFromHome: 'ನೋಂದಾಯಿತ ಕಚೇರಿ ವಿಳಾಸ',
    submit: 'ಸಲ್ಲಿಸಿ',
    tncOne: 'ಸಂಪೂರ್ಣ',
    tncTwo: 'ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳನ್ನು',
    tncThree: 'ಓದಿ',
    courseTitle: 'Select Course/Certificate',
    minEducation: 'Minimum Education',
    selectCoursePlaceholder: 'Select Course Name',
    courseName: 'Course name',
    optional: 'optional',
    experience: 'Experience',
    postingLocationMessage: 'You will receive candidates from',
    postingLocationModalTitle: 'Select hiring location',
    postingLocationSearchPlaceHolder: 'Search cities',
    //commented till translations not provided
    // proceedToPaySubtext: 'We follow fair use and privacy rules. Breaking policies or fraud can lead to account suspension and loss of service fees.',
    // checkout: 'Checkout',
    // checkoutInfo: 'Review your order and proceed with payment to unlock your benefits.',
    // orderSummary: 'Order Summary'
  },
  postJobErrorStates: {
    noOptions: 'ದಯವಿಟ್ಟು ನಿಮ್ಮ ಆಯ್ಕೆಯನ್ನು ಆರಿಸಿ',
    wrongValue: 'ದಯವಿಟ್ಟು ಸರಿಯಾದ ಮೌಲ್ಯ ನಮೂದಿಸಿ',
    noOpenings: 'ದಯವಿಟ್ಟು ಓಪನಿಂಗ್ಸ್ ಇರುವ ಸಂಖ್ಯೆಯನ್ನು ನಿರ್ದಿಷ್ಟಪಡಿಸಿ',
    noMonthlySalary: 'ದಯವಿಟ್ಟು ಮಾಸಿಕ ವೇತನ ನಮೂದಿಸಿ',
    lowMinSalary: 'ದಯವಿಟ್ಟು ಕನಿಷ್ಠ ವೇತನವು 1000 ಕ್ಕಿಂತ ಕಡಿಮೆ ಇಲ್ಲ ಎಂದು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ',
    highMinSalary: 'ಕನಿಷ್ಠ ಮಾಸಿಕ ವೇತನ ರೂ.1,00,000 ಕ್ಕಿಂತ ಕಡಿಮೆಯಿರಬೇಕು.',
    noFeeAmount: 'ದಯವಿಟ್ಟು ಶುಲ್ಕದ ಮೊತ್ತವನ್ನು ನಮೂದಿಸಿ (ಅಲ್ಲಿ ₹)',
    lowMaxSalary: 'ದಯವಿಟ್ಟು ಗರಿಷ್ಠ ವೇತನವು 1000 ಕ್ಕಿಂತ ಕಡಿಮೆ ಇಲ್ಲ ಎಂದು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ',
    highMaxSalary: 'ಗರಿಷ್ಠ ಮಾಸಿಕ ವೇತನ ರೂ.1,00,000 ಕ್ಕಿಂತ ಕಡಿಮೆಯಿರಬೇಕು.',
    minGreaterMax: 'ಗರಿಷ್ಠ ವೇತನವು ಕನಿಷ್ಠ ವೇತನಕ್ಕಿಂತ ಹೆಚ್ಚಿರಬೇಕು',
    noTextArea: 'ದಯವಿಟ್ಟು ಟೆಕ್ಸ್ಟ್ ಏರಿಯಾ ಭರ್ತಿ ಮಾಡಿ',
    noPhoneNumber: 'ದಯವಿಟ್ಟು ಫೋನ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ',
    noConsultancyName: 'ದಯವಿಟ್ಟು ಕನ್ಸಲ್ಟೆನ್ಸಿ ಸಂಸ್ಥೆಯ ಹೆಸರನ್ನು ನಮೂದಿಸಿ',
    noCompanyName: 'ದಯವಿಟ್ಟು ಕಂಪನಿಯ ಹೆಸರನ್ನು ನಮೂದಿಸಿ',
    noCompanyType: 'ದಯವಿಟ್ಟು ನಿಮ್ಮ ಕಂಪನಿಯ ವಿಧವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    noDataFound: 'No Data Found'
  }
}
